module.exports = __webpack_public_path__ + "img/solution-data-logo6.e581904c.png";